import { render, staticRenderFns } from "./HoraryNewLayout.vue?vue&type=template&id=2b8de99a&scoped=true&"
import script from "./HoraryNewLayout.vue?vue&type=script&lang=js&"
export * from "./HoraryNewLayout.vue?vue&type=script&lang=js&"
import style0 from "./HoraryNewLayout.vue?vue&type=style&index=0&id=2b8de99a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b8de99a",
  null
  
)

export default component.exports